import { FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { PasswordValidation } from "../enums/password-validation";

export function passwordValidator(): ValidatorFn {
  return (control: FormControl<string>): ValidationErrors | null => {
    const hasUppercase = /[A-Z]+/.test(control.value);
    const hasLowercase = /[a-z]+/.test(control.value);
    const hasNumbers = /[0-9]+/.test(control.value);
    const hasNonAlphas = /[!@#$%^&*)(+=._-]+/.test(control.value);
    const requirements = {
      [PasswordValidation.Uppercase]: !hasUppercase,
      [PasswordValidation.Lowercase]: !hasLowercase,
      [PasswordValidation.Numbers]: !hasNumbers,
      [PasswordValidation.NonAlphas]: !hasNonAlphas,
    };
    const toMeetCount = 3;
    const metCount = Object.values(requirements).filter((r) => !r).length;
    const isValid = metCount >= toMeetCount;
    control["requirement"] =
      isValid && toMeetCount === 3
        ? Object.entries(requirements).find((r) => r[1])?.[0]
        : undefined;
    return isValid ? null : requirements;
  };
}
